export default __webpack_public_path__ + "static/media/tempTrailerBg.6fb9a723.jpg";